import React, { ReactNode } from 'react';

interface ChipProps {
  children: ReactNode;
  className?: string;
}

const Chip = ({ children, className }: ChipProps): JSX.Element => {
  return (
    <div
      className={`p-1 pl-2.5 pr-2.5 bg-surface-neutral-faded bg-opacity-18 border border-outline-positive-faded border-opacity-18 flex items-center rounded-xl ${className}`}
    >
      {children}
    </div>
  );
};

export default Chip;
